import React, { useContext, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import ProposedPortfolioDataTable from "./ProposedPortfolioDataTable";

import ActiveComponentContext from "../../../contexts/ActiveComponentContext";
import useOutputReportStore from "../../../store/OutputReport.store";

const ProposedPortfolio = () => {
  const reportName = "Portfolio";
  const data = useOutputReportStore((state) => state.data);
  const { active: activeId, setActive: setActiveComponent } = useContext(
    ActiveComponentContext
  );
  const { ref, entry } = useInView({
    /* Optional options */
    threshold: 0.25,
    trackVisibility: true,
    delay: 100,
  });

  useEffect(() => {
    if (entry?.isVisible && entry?.target?.id !== activeId) {
      setActiveComponent(entry.target.id);
    }
  }, [entry, setActiveComponent, activeId]);

  if (!data?.[reportName]) {
    return null;
  }

  // RM-2276: the code below works when debugging but results in dates being replaced by empty strings
  // Object.keys(data.Portfolio["Maturity Date"]).forEach((key, value) => {
  //   data.Portfolio["Maturity Date"][key] = convertDateWithHyphen(
  //     data.Portfolio["Maturity Date"][key]
  //   );
  //   return data.Portfolio["Maturity Date"];
  // });

  return (
    <article ref={ref} id="Portfolio" className="report-article">
      <header className="section-title report-article__header">
        <h1>Target Portfolio [1]</h1>
      </header>

      <div className="report-article__content">
        <section className="report-article__visual">
          <ProposedPortfolioDataTable />
        </section>
      </div>
    </article>
  );
};

export default ProposedPortfolio;
